<template>
  <div class="ant-pro-pages-account-projects-cardList">
    <a-list
      :loading="loading"
      :data-source="data"
      :grid="{ gutter: 24, xxl: 3, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }"
    >
      <template v-slot:renderItem="item">
        <a-list-item>
          <a :href="item.url" target="_blank">
            <a-card class="ant-pro-pages-account-projects-card" hoverable>
              <template v-slot:cover>
                <img :src="item.cover" :alt="item.title" />
              </template>
              <a-card-meta :title="item.title">
                <template v-slot:description>
                  <ellipsis :length="50">{{ item.description }}</ellipsis>
                </template>
              </a-card-meta>
              <div class="cardItemContent">
                <span>{{ fromNow_filter(item.updatedAt) }}</span>
              </div>
            </a-card>
          </a>
        </a-list-item>
      </template>
    </a-list>
  </div>
</template>

<script>
import moment from 'moment'
import { TagSelect, StandardFormRow, Ellipsis, AvatarList } from '@/components'
const TagSelectOption = TagSelect.Option
const AvatarListItem = AvatarList.AvatarItem

export default {
  name: 'Project',
  components: {
    AvatarList,
    AvatarListItem,
    Ellipsis,
    TagSelect,
    TagSelectOption,
    StandardFormRow,
  },
  data() {
    return {
      data: [
        {
          title: 'RuoYi-Vue',
          cover: 'https://oss.fuzui.net/img/20210116014248.png',
          url: '#',
          description: '',
        },
        {
          title: 'Ant Design Vue',
          cover: 'https://oss.fuzui.net/img/20210116014908.png',
          url: '#',
          description:
            'An enterprise-class UI components based on Ant Design and Vue. ',
        },
        {
          title: 'Antd Pro Vue',
          cover: 'https://oss.fuzui.net/img/20210116014556.png',
          url: '#',
          description: '',
        },
        {
          title: 'wangEditor',
          cover: 'https://oss.fuzui.net/img/202112030159554.png',
          url: '#',
          description: '',
        },
      ],
      form: this.$form.createForm(this),
      loading: false,
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    fromNow_filter(date) {
      return moment(date).fromNow()
    },
    handleChange(value) {},
    getList() {},
  },
}
</script>

<style lang="less" scoped>
.ant-pro-pages-account-projects-cardList {
  margin-top: 24px;
  /deep/ .ant-card-meta-title {
    margin-bottom: 4px;
  }

  /deep/ .ant-card-meta-description {
    height: 44px;
    overflow: hidden;
    line-height: 22px;
  }

  .cardItemContent {
    display: flex;
    height: 20px;
    margin-top: 16px;
    margin-bottom: -4px;
    line-height: 20px;

    > span {
      flex: 1 1;
      color: rgba(0, 0, 0, 0.45);
      font-size: 12px;
    }

    /deep/ .ant-pro-avatar-list {
      flex: 0 1 auto;
    }
  }
}
</style>
